import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, CalendarCheck } from 'lucide-react';
import { Button } from './ui/button';
import { heroData, siteConfig } from '../data/mock';
import { trackWhatsAppClick } from '../lib/analytics';

const HeroSection = () => {
  const scrollToForm = () => {
    const element = document.querySelector('#formulario');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden hero-gradient">
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-accent-pink-200/30 rounded-full blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-accent-orange-200/30 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 md:px-8 pt-24 pb-16 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {/* Text Content - Left Side */}
          <div className="text-center lg:text-left order-2 lg:order-1">
            {/* Main heading */}
            <motion.h1
              className="heading-hero mb-4"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              {heroData.title}
            </motion.h1>

            {/* Name */}
            <motion.p
              className="text-2xl md:text-3xl font-medium mb-8"
              style={{ color: '#5B9A6F' }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              {siteConfig.name}
            </motion.p>

            {/* Subtitle */}
            <motion.p
              className="body-large text-secondary max-w-xl mb-10"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              {heroData.subtitle}
            </motion.p>

            {/* CTA Buttons */}
            <motion.div
              className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              <a
                href={siteConfig.whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackWhatsAppClick('hero')}
                data-testid="whatsapp-btn-hero"
              >
                <Button className="btn-primary rounded-full px-8 py-6 text-base gap-2 w-full sm:w-auto">
                  <MessageCircle className="w-5 h-5" />
                  {heroData.ctaPrimary}
                </Button>
              </a>
              <Button
                variant="outline"
                className="btn-secondary rounded-full px-8 py-6 text-base gap-2"
                onClick={scrollToForm}
              >
                <CalendarCheck className="w-5 h-5" />
                {heroData.ctaSecondary}
              </Button>
            </motion.div>
          </div>

          {/* Image - Right Side */}
          <motion.div
            className="relative order-1 lg:order-2 flex justify-center lg:justify-end"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            <div className="relative max-w-md lg:max-w-lg">
              <img
                src="https://customer-assets.emergentagent.com/job_fabio-mascota/artifacts/agwd8j67_IMG_7399.jpeg"
                alt="Labrador tranquilo y feliz"
                className="w-full h-auto object-contain"
                style={{ maxHeight: '550px' }}
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
